import { QualificationBadge } from 'components/badges';
import { QualificationPreviousMonthBadge } from 'components/badges/qualification/QualificationPreviousMonthBadge';
import { RankBadge } from 'components/badges/qualification/RankBadge';
import { ContentContainer } from 'components/containers';
import { FormattedUnitValue } from 'components/text';
import { useBoolean } from 'hooks';
import { t } from 'i18next';
import { FeatureIcon, FeatureIconName } from 'libs/icons';
import _ from 'lodash';
import { IUserProfile } from 'types';

import { WidgetQualificationDetails } from '../../qualification/WidgetQualificationDetails';

interface IQualificationColumProps {
  readonly userProfile: IUserProfile;
}

export function CurrentQualificationColumn(props: IQualificationColumProps) {
  const [isOpen, { setFalse: close, setTrue: open }] = useBoolean(false);

  const businessData = props.userProfile.businessData;
  if (
    props.userProfile.isDiscountCustomer &&
    businessData?.nextQualificationProgress
  ) {
    return <span></span>;
  }

  return (
    <>
      <button
        className="inline-block"
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          open();
        }}
      >
        {props.userProfile.qualification ? (
          <QualificationBadge
            qualification={props.userProfile.qualification}
            hideDetails={true}
          />
        ) : businessData?.nextQualificationProgress?.percent &&
          businessData?.nextQualificationLevel ? (
          <div className="flex flex-row items-center gap-1">
            <span className="text-sm text-primary">
              <FormattedUnitValue
                value={businessData?.nextQualificationProgress.percent}
                unit="percent"
              />
            </span>
            <QualificationBadge
              qualification={businessData?.nextQualificationLevel}
              hideDetails={true}
              unachieved={true}
            />
          </div>
        ) : null}
      </button>
      {businessData?.nextQualificationProgress && (
        <ContentContainer
          onDismiss={close}
          open={isOpen}
          icon={
            <FeatureIcon
              name={FeatureIconName.Qualification}
              className={`inline-block`}
              size={16}
            />
          }
          title={t('Current qualification')}
        >
          {isOpen && (
            <WidgetQualificationDetails
              userId={props.userProfile.userId}
              nextQualificationLevel={businessData?.nextQualificationLevel}
              nextQualificationProgress={
                businessData?.nextQualificationProgress
              }
              qualificationHistory={businessData?.qualificationHistory}
              currentQualificationLevel={props.userProfile.qualification}
              canReachCheckAssurance={
                !_.isUndefined(businessData.checkAssuranceProgress)
              }
            />
          )}
        </ContentContainer>
      )}
    </>
  );
}

export function PreviousMonthQualificationColumn(
  props: IQualificationColumProps
) {
  if (
    props.userProfile.isDiscountCustomer ||
    _.isUndefined(props.userProfile.businessData) ||
    _.isUndefined(props.userProfile.businessData.lastMonthQualificationLevel)
  ) {
    return <span></span>;
  }

  return (
    <QualificationPreviousMonthBadge
      qualification={props.userProfile.businessData.lastMonthQualificationLevel}
    />
  );
}

export function HighesthQualificationColumn(props: IQualificationColumProps) {
  if (
    props.userProfile.isDiscountCustomer ||
    _.isUndefined(props.userProfile.rank)
  ) {
    return <span></span>;
  }

  return <RankBadge rank={props.userProfile.rank} />;
}
